console.log("observer loaded");
document.querySelector("#main-nav")

jQuery(document).ready(function($) {

    // cookie plugin check
    if (typeof $.cookie !== "undefined") {

        if ($.cookie("close") == null) {

            function show_modal() {
                $('#AisModalCenter').modal('show');
            }

            setTimeout(show_modal, 1000);
        }

        $(".close").click(function () {

            var date = new Date();
            date.setTime(date.getTime() + (1 * 60 * 1000));

            $.cookie("close", "true", {
                expires: date,
                path: '/'
            });

        });
    }


    if ($.fn.owlCarousel) {


        $("#headlines").owlCarousel({
                dots:true, autoplay: true, items:1});
            
        $('#owl-carousel-02').owlCarousel({
                    center: true,
                        items:2,
                        loop:true,
                        margin:20,
                        autoplay: true,
                        autoplayTimeout: 3000,
                        autoplayHoverPause: true,
            responsive:{
                            576:{
                                items:3
                            },
                            992:{
                                items:6
                            }
                        }
            });
    }
     
    $('#owl-share').owlCarousel({
    dots:true, autoplay: true, items:5});

    $('#owl-share-option').owlCarousel({
    dots:true, autoplay: true, items:5});
     
    $('#owl-private-option').owlCarousel({
    dots:true, autoplay: true, items:5});

    $('#owl-server-options').owlCarousel({
    dots:true, autoplay: true, items:3});
     


     
    $('a[data-toggle="pill"]:first-child').addClass('active');
   
    $('#v-pills-tabContent div:first-child').addClass('show active');
     
     
    var topBtn = $('.fixed-top');
    var gotop = $('#page-top');

    var mainvav = $('#main-nav');

    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            topBtn.addClass('is-scrolled');
            gotop.addClass('let');
            mainvav.addClass('is-fixed');

        } else {
            topBtn.removeClass('is-scrolled');
            gotop.removeClass('let');
            mainvav.removeClass('is-fixed');

        }
    });
    
     

    // smooth scroll safe version
    $('a[href*="#"]:not([data-toggle="dropdown"])').click(function () {

        var href = $(this).attr("href");
        var target = $(href);

        if (target.length) {
            var position = target.offset().top - 113;
            $('body,html').animate({
                scrollTop: position
            }, 200, "swing");
        }

        return false;
    });


});


/** BOF domain check */

(function () {
    // JS 側で厳密チェック
    const strictRegex = /^(?!-)(?!.*--)[a-zA-Z0-9-]{3,63}(?<!-)$/;

    function validateInput(input) {
        input.addEventListener('input', function () {
            if (!strictRegex.test(input.value)) {
                input.setCustomValidity(
                    '英数字とハイフンのみ、3〜63文字で入力してください（先頭末尾ハイフン・連続ハイフン禁止）'
                );
            } else {
                input.setCustomValidity('');
            }
        });
    }

    function initForm() {
        const input = document.querySelector('#dc-domain-1');
        const form = document.querySelector('#dc-form-1');

        if (!input || !form) return false;

        // 入力イベントにバリデーションをセット
        validateInput(input);

        // submit時も必ずチェック
        form.addEventListener('submit', function (e) {
            if (!strictRegex.test(input.value)) {
                e.preventDefault();
                alert('英数字とハイフンのみ、3〜63文字で入力してください（先頭末尾ハイフン・連続ハイフン禁止）');
                input.focus();
            }
        });

        return true;
    }

    function waitForForm() {
        if (initForm()) return;

        // 動的生成される場合に対応
        const observer = new MutationObserver(function () {
            if (initForm()) observer.disconnect();
        });

        if (!document.body) {
            setTimeout(waitForForm, 50);
            return;
        }

        observer.observe(document.body, { childList: true, subtree: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', waitForForm);
    } else {
        waitForForm();
    }
})();








import Tooltip from 'bootstrap/js/dist/tooltip'

document.addEventListener('DOMContentLoaded', () => {
    document
        .querySelectorAll('[data-bs-toggle="tooltip"]')
        .forEach(el => new Tooltip(el))
})

